<template>
  <div class="rkfx-processes">
    <div class="flex justify-between px-5 py-3">
      <div class="my-auto h-full text-lg font-semibold">협력사</div>
      <button class="cs-icon-btn" @click="onChangeShow"><i class="fi fi-br-cross"></i></button>
    </div>
    <div v-if="currentModel" class="px-8 py-5">
      <div v-for="process in processList" :key="process.id" class="mb-10">
        <div class="text-4xl font-bold border-b border-line">{{ process.name }}</div>
        <div v-for="material in process.matarials" :key="material.id" class="pl-4 mt-7">
          <div class="pb-2 text-xl font-semibold border-b border-line">{{ material.name }}</div>
          <div class="flex px-3 py-3 text-sm border-b border-line bg-hover text-desc">
            <div style="min-width: 15rem; max-width: 15rem">협력사</div>
            <div style="width: 100%">장비</div>
            <div style="min-width: 15rem; max-width: 15rem">출력크기</div>
            <div style="min-width: 10rem; max-width: 10rem">단가</div>
            <div style="min-width: 10rem; max-width: 10rem">최소비용</div>
          </div>
          <div
            v-for="company in material.companys"
            :key="company.id"
            class="flex px-3 py-4 border-b border-line text-desc"
            :class="{'rkfx-active': currentModel.modelCompanyId === company.id}"
            style="min-width: 0"
          >
            <div style="min-width: 15rem; max-width: 15rem">{{ company.name }}</div>
            <div class="pr-1 cs-ellipsis1" style="width: 220px; max-width: 220px">
              {{ company.printer }}
            </div>
            <div style="min-width: 15rem; max-width: 15rem">
              {{ `${company.buildX}x${company.buildY}x${company.buildZ}` }}
            </div>
            <div class="font-semibold text-second" style="min-width: 10rem; max-width: 10rem">
              {{ unitCost(company) }}원
            </div>
            <div style="min-width: 10rem; max-width: 10rem">{{ company.minCost }}원</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/******************************************
 * 하이쓰리디 - 설정의 공정 리스트 행
 ******************************************/

import {ref} from "vue";
import {storeToRefs} from "pinia";
import {CompanyStore} from "../../store/company-store";
import {numberToComma} from "../../js/utils";

const companyStore = CompanyStore();
const {processList} = storeToRefs(companyStore);

const props = defineProps({
  currentModel: {
    type: Object,
  },
});

const emit = defineEmits(["onShow"]);

const isShow = ref(true);
const modelVolume = ref(0);

const onChangeShow = () => {
  isShow.value = !isShow.value;
  emit("onShow", isShow.value);
};

const unitCost = (company) => {
  if (props.currentModel) {
    modelVolume.value = props.currentModel.modelVolume;
  }
  const v = modelVolume.value;
  const cost = company.costRate * v;
  const c = numberToComma(Math.floor(cost));
  return c;
};
</script>

<style scoped lang="scss">
.rkfx {
  &-processes {
    @apply overflow-hidden rounded-md border border-line bg-white;

    top: 0px;
    width: 100%;
  }

  &-active {
    background-color: #d9f2ff;
  }
}
</style>
